import React from 'react';
import { firestore } from '../contexts/FirebaseContext';
import useOriginAction from './useOriginAction';

function useQrAction() {
  const { originAplication, originServer } = useOriginAction();

  // verifyReferenceCode crear el registro del codigo qr usando un codigo de referencia que le enviamos a la funcion en este caso es el nip (el nombre verifyReferenceCode no ayuda mucho pero no se me ocurrio algo mejor xd)
  // eslint-disable-next-line consistent-return
  const createQrRegWithReference = async (referenceCode, relatedProduct, service, reason) => {
    try {
      const getUser = await firestore.collection('users').where('nip', '==', referenceCode).get();
      const dataObj = getUser.docs.map((item) => ({ id: item.id, ...item.data() }))[0];

      const regQrObj = {
        userId: dataObj.id,
        rolUser: dataObj.role,
        status: 'PENDING',
        referenceCode,
        relatedProduct,
        byReferenceCode: true,
        service,
        reason,
        originServer,
        originAplication,
        createdAt: new Date(),
        updatedAt: new Date()
      };

      const regQr = await firestore.collection('reg_qr').add(regQrObj);

      //   return { ...dataObj, id: regQr.id };
      return regQr.id;
    } catch (error) {
      console.log(error);
    }
  };

  // eslint-disable-next-line consistent-return
  const createQrRegWithoutReference = async (relatedProduct, service, reason) => {
    try {
      // const getUser = await firestore.collection('users').where('nip', '==', referenceCode).get();
      // const dataObj = getUser.docs.map((item) => ({ id: item.id, ...item.data() }))[0];

      const regQrObj = {
        userId: null,
        rolUser: null,
        status: 'PENDING',
        referenceCode: null,
        byReferenceCode: false,
        relatedProduct,
        service,
        reason,
        originServer,
        originAplication,
        createdAt: new Date(),
        updatedAt: new Date()
      };

      const regQr = await firestore.collection('reg_qr').add(regQrObj);

      //   return { ...dataObj, id: regQr.id };
      return regQr.id;
    } catch (error) {
      console.log(error);
    }
  };

  const getRegQrData = async (idReg, callbackFunc) =>
    firestore
      .collection('reg_qr')
      .doc(idReg)
      .onSnapshot((doc) => {
        callbackFunc(doc.data());
      });

  return { createQrRegWithReference, createQrRegWithoutReference, getRegQrData };
}

export default useQrAction;
